"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function NotificationContainer(_ref) {
  var list = _ref.list,
    position = _ref.position,
    handleCloseToaster = _ref.handleCloseToaster;
  return list === null || list === void 0 ? void 0 : list.map(function (toast, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "notification-container ".concat(position ? position : "center-center")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "notification toast",
      style: {
        backgroundColor: toast.backgroundColor
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "notification-image"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: toast.icon,
      alt: ""
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "notification-title"
    }, toast.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "notification-message"
    }, toast.description), (toast === null || toast === void 0 ? void 0 : toast.button) && /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        return handleCloseToaster(toast.id, toast);
      }
    }, toast.button)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-backdrop-notification generic-message-backdrop"
    }));
  });
}
var _default = NotificationContainer;
exports.default = _default;